// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32":"93a8617e","280":"9aa7e229","302":"8d03a792","407":"b1fd1a18","436":"93a8617e","631":"93a8617e","684":"93a8617e"}[chunkId] + ".chunk.css";
};